<template>
	<v-navigation-drawer
		v-model="value"
		app
		clipped
		dark
		right
	>
		<!-- The 'CLOSE' button to hide the navigation drawer. -->
		<v-btn large block flat @click.stop="$emit('toggle')">
			<v-icon left>close</v-icon>
			CLOSE
			<v-spacer />
			<v-icon right>exit_to_app</v-icon>
		</v-btn>

		<v-divider />

		<!-- The vertical list / group of navigation links in the drawer. -->
		<!-- Loop over the link data array ( item -> { href, text } ). -->
		<template v-for="(item, i) in navLinks">
			<component
				:is="item.comp"
				v-if="item.comp"
				:key="'appNavDrawerItem' + i"
				:btn-props="btnProps"
			/>

			<v-btn
				v-else-if="item.href && item.href.split('.').pop() == 'pdf'"
				:key="item.href"
				v-external
				:href="item.href"
				block
				flat
			>
				<v-spacer />
				{{ item.text }}
				<v-icon small right>open_in_new</v-icon>
			</v-btn>

			<v-btn
				v-else
				:key="item.href"
				:href="item.href"
				class="pr-5"
				block
				flat
				@click="$emit('toggle')"
			>
				<v-spacer />
				{{ item.text }}
			</v-btn>
		</template>
	</v-navigation-drawer>
</template>

<script>
export default {
	props: {
		navLinks: {
			type: Array,
			required: true,
		},
		value: {
			type: Boolean,
			required: true,
		},
	},

	data: () => ({
		btnProps: {
			class: 'pr-5',
			block: true,
		},
	}),
}
</script>
